import { Injectable } from '@angular/core';
import { CeuEvents } from 'icreate/common/io-event/websocket-message';
import { SocketMiddlewareService } from './socket-middleware.service';

@Injectable({
    providedIn: 'root',
})
export class CeuUnitSocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    unitCreated$() {
        return this.socketService.receiveMessageObserver(CeuEvents.CEU_UNIT_CREATED);
    }

    unitUpdated$() {
        return this.socketService.receiveMessageObserver(CeuEvents.CEU_UNIT_UPDATED);
    }

    unitDeleted$() {
        return this.socketService.receiveMessageObserver(CeuEvents.CEU_UNIT_DELETED);
    }

    portsUpdated$() {
        return this.socketService.receiveMessageObserver(CeuEvents.PORTS_UPDATED);
    }
}
